import { render, staticRenderFns } from "./SyncBind.vue?vue&type=template&id=806098b0&scoped=true"
import script from "./SyncBind.vue?vue&type=script&lang=js"
export * from "./SyncBind.vue?vue&type=script&lang=js"
import style0 from "./SyncBind.vue?vue&type=style&index=0&id=806098b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806098b0",
  null
  
)

export default component.exports